import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv2210GetResultModel, Inv2210GetResultSchema } from './get.schema'

export async function fetchInv2210(id: number): Promise<Inv2210GetResultModel> {
  const response = await axios.get<Inv2210GetResultModel>(
    `/api/warehouse/inv2210/${id}`
  )
  console.log('fetchInv2210', response.data)
  return Inv2210GetResultSchema.parse(response.data)
}

export const getInv2210ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv2210', id],
    queryFn: () => fetchInv2210(id),
  })
